(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlt-glass-appointments"] && !Shopify.designMode) return;
  try {
    
(() => {
 const form=document.getElementById('NltGlassAppointment');
 if(!form||form.dataset.ready)return;form.dataset.ready='true';
 const el=id=>document.getElementById(id),messages=JSON.parse(el('GlassMessages').textContent);
 const date=el('GlassDate'),time=el('GlassTime'),submit=el('GlassSubmit'),status=el('GlassBookingStatus'),slotsStatus=el('GlassSlotsStatus');
 const endpoint=(window.Shopify?.routes?.root||'/')+'apps/nlt-taller/glass/';
 const mode=el('GlassMode'),isHome=()=>mode.value==='home';
 let csrf='',busy=false,uncertain=false,sequence=0,staffCsrf='',memoryKey=null;
 const hour=t=>{const n=Number(t.slice(0,2));return (n%12||12)+':'+t.slice(3,5)+' '+(n<12?'a. m.':'p. m.');};
 const dayLabel=d=>new Intl.DateTimeFormat('es-MX',{dateStyle:'long',timeZone:'UTC'}).format(new Date(d+'T12:00:00Z'));
 const node=(tag,text)=>{const e=document.createElement(tag);e.textContent=text;return e;};
 async function api(path,body,token){
  const response=await fetch(endpoint+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json','X-CSRF-Token':token}:{},body:body?JSON.stringify(body):undefined,signal:AbortSignal.timeout(20000)});
  let data;try{data=await response.json();}catch{throw Error(messages.request_error);}
  if(!response.ok||data.ok===false)throw Object.assign(Error(data.error||messages.request_error),{status:response.status});
  return data;
 }
 function updateSubmit(){submit.disabled=busy||!csrf||(!uncertain&&(isHome()?!date.value:(!time.value||time.disabled)));}
 async function loadSlots(){
  if(busy||uncertain||form.hidden)return;
  const request=++sequence,selected=time.value,selectedDate=date.value;
  time.disabled=true;updateSubmit();slotsStatus.textContent=messages.loading_slots;
  try{
   const r=await api('availability'+(selectedDate?'?date='+encodeURIComponent(selectedDate):''));
   if(request!==sequence)return;
   csrf=r.csrf_token;date.min=r.min_date;date.max=r.max_date;
   time.replaceChildren(new Option(selectedDate?messages.choose_time:messages.choose_date,''));
   if(isHome()){time.disabled=true;slotsStatus.textContent=messages.home_pending;}
   else if(selectedDate){
    r.slots.forEach(t=>time.add(new Option(hour(t)+' – '+hour(String(Number(t.slice(0,2))+1).padStart(2,'0')+':00'),t)));
    if(r.slots.includes(selected))time.value=selected;
    time.disabled=r.slots.length===0;
    slotsStatus.textContent=r.slots.length?r.slots.length+' '+messages.available:messages.no_slots;
   }else{slotsStatus.textContent=messages.choose_date;}
  }catch(e){if(request!==sequence)return;time.replaceChildren(new Option(messages.choose_date,''));csrf='';slotsStatus.textContent=e.message;}
  updateSubmit();
 }
 function toggleMode(){
  const home=isHome();el('GlassHomeFields').hidden=!home;
  for(const id of ['GlassZip','GlassAddress']){el(id).disabled=!home;el(id).required=home;}
  el('GlassDateLabel').textContent=home?messages.home_preferred:messages.date;el('GlassSlotNote').hidden=home;
  time.closest('label').hidden=home;time.required=!home;submit.textContent=home?messages.home_send:messages.send;
  loadSlots();updateSubmit();
 }
 mode.addEventListener('change',toggleMode);
 date.addEventListener('change',()=>{time.value='';loadSlots();});
 time.addEventListener('change',updateSubmit);el('GlassRefresh').addEventListener('click',loadSlots);
 const damageList=el('GlassDamages');
 const damageChecks=[...damageList.querySelectorAll('input[type=checkbox]')];
 const damageNames=Object.fromEntries(damageChecks.map(r=>[r.value,r.dataset.typeLabel]));
 function damageRows(){return [...damageList.querySelectorAll('[data-damage-row]')].filter(row=>row.querySelector('input[type=checkbox]').checked);}
 function syncDamages(){
  for(const row of damageList.querySelectorAll('[data-damage-row]')){
   const checked=row.querySelector('input[type=checkbox]').checked;
   row.querySelector('[data-details]').hidden=!checked;
   row.querySelectorAll('[data-size],[data-count]').forEach(input=>input.disabled=!checked||busy||uncertain);
  }
  const rows=damageRows(),total=rows.reduce((n,row)=>n+(Number(row.querySelector('[data-count]').value)||0),0);
  el('GlassDamageTotal').textContent=rows.length?messages.damage_total+': '+total:messages.choose_damages;
  damageChecks[0].setCustomValidity(rows.length?'':messages.choose_damages);
 }
 damageList.addEventListener('change',syncDamages);damageList.addEventListener('input',syncDamages);syncDamages();
 function damageSummary(item){return (item.damages||[{damage_type:item.damage_type,size_cm:item.size_cm,count:item.count}]).map((d,i)=>messages.damage_number+' '+(i+1)+': '+(damageNames[d.damage_type]||d.damage_type)+' · '+(d.size_cm==null?messages.measure_missing:d.size_cm+' cm')+' · '+messages.count_short+': '+d.count).join('\n');}
 async function requestKey(payload){
  const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(JSON.stringify(payload)));
  const hash=Array.from(new Uint8Array(bytes),b=>b.toString(16).padStart(2,'0')).join('');
  let prior=memoryKey;try{prior=JSON.parse(sessionStorage.getItem('nlt-glass-pending'))||prior;}catch{}
  if(prior?.hash!==hash)prior={hash,id:crypto.randomUUID()};
  memoryKey=prior;try{sessionStorage.setItem('nlt-glass-pending',JSON.stringify(prior));}catch{}
  return prior.id;
 }
 form.addEventListener('submit',async event=>{
  event.preventDefault();if(busy||!form.reportValidity()||(!isHome()&&!time.value)||!csrf)return;
  const damages=damageRows().map(row=>({damage_type:row.querySelector('input[type=checkbox]').value,size_cm:row.querySelector('[data-size]').value===''?null:Number(row.querySelector('[data-size]').value),count:Number(row.querySelector('[data-count]').value)}));
  if(!damages.length||damages.reduce((n,d)=>n+d.count,0)>50){status.className='nlt-glass-error';status.textContent=messages.damage_limit;status.focus();return;}
  const p={name:el('GlassName').value.trim(),phone:el('GlassPhone').value.trim(),email:el('GlassEmail').value.trim(),vehicle:el('GlassVehicle').value.trim(),date:date.value,time:isHome()?'08:00':time.value,damages,damage_type:damages[0].damage_type,size_cm:damages[0].size_cm,count:damages.reduce((n,d)=>n+d.count,0),notes:el('GlassDamage').value.trim()};
  if(isHome()){p.service_mode='home';p.zip=el('GlassZip').value.trim();p.address=el('GlassAddress').value.trim();}
  busy=true;submit.disabled=true;submit.textContent=messages.booking;status.className='';status.textContent=messages.booking;
  const inputs=[...form.querySelectorAll('input,select,textarea,button')];inputs.forEach(e=>e.disabled=true);
  try{
   p.request_id=await requestKey(p);
   const r=await api(isHome()?'home-request':'book',p,csrf),done=el('GlassBooked');
   if(isHome())done.replaceChildren(node('h3',messages.home_sent),node('strong',messages.folio+': '+r.folio),node('p',r.status==='pending'?messages.home_pending:messages.home_handled));
   else done.replaceChildren(node('h3',messages.booked),node('strong',messages.folio+': '+r.folio),node('p',dayLabel(r.date)+' · '+hour(r.time)+' – '+hour(r.end_time)),node('p',messages.booking_note));
   done.hidden=false;form.hidden=true;done.focus();
   try{sessionStorage.removeItem('nlt-glass-pending');}catch{}
   if(staffCsrf){loadStaff();loadHomeRequests();}
  }catch(e){uncertain=!e.status||e.status>=500;status.className='nlt-glass-error';status.textContent=e.message+(uncertain?' '+messages.uncertain:'');status.focus();}
  finally{busy=false;inputs.forEach(e=>e.disabled=uncertain);submit.textContent=isHome()?messages.home_send:messages.send;if(!uncertain){el('GlassZip').disabled=!isHome();el('GlassAddress').disabled=!isHome();}syncDamages();updateSubmit();if(!form.hidden)loadSlots();}
 });
 let staffSequence=0;
 async function loadStaff(){
  const dateValue=el('GlassStaffDate').value;if(!staffCsrf||!dateValue)return;
  const request=++staffSequence,list=el('GlassStaffList');list.textContent=messages.staff_loading;
  try{
   const r=await api('appointments?date='+encodeURIComponent(dateValue));if(request!==staffSequence)return;
   list.replaceChildren();
   if(!r.items.length)list.textContent=messages.no_appointments;
   for(const item of r.items){
    const row=node('div','');row.className='nlt-glass-staff-row';
    const type=damageSummary(item);
    row.append(node('h3',hour(item.time)+' · '+item.name),node('p',[item.phone,item.email,item.vehicle,type,messages.count_short+': '+item.count,item.kind==='home'?[messages.home_mode,item.address,item.zip,item.km+' km',messages.home_quote+': '+item.travel_price+' MXN',item.duration_minutes+' min'].join(' · '):'',item.notes].filter(Boolean).join('\n')));
    const cancel=node('button',messages.cancel_booking);cancel.type='button';
    cancel.addEventListener('click',async()=>{
     if(!window.confirm(messages.cancel_confirm))return;cancel.disabled=true;
     try{await api('cancel',{id:item.id,date:item.date,time:item.time},staffCsrf);await loadStaff();loadSlots();}
     catch(e){row.append(node('p',e.message));cancel.disabled=false;}
    });
    row.append(cancel);list.append(row);
   }
  }catch(e){if(request===staffSequence)list.textContent=e.message;}
 }
 el('GlassStaffDate').addEventListener('change',loadStaff);el('GlassStaffRefresh').addEventListener('click',loadStaff);
 let homeSequence=0;
 async function loadHomeRequests(){
  if(!staffCsrf)return;const request=++homeSequence,list=el('GlassHomeRequests');list.textContent=messages.staff_loading;
  try{
   const r=await api('home-requests');if(request!==homeSequence)return;list.replaceChildren();
   if(!r.items.length)list.textContent=messages.home_none;
   for(const item of r.items){
    const row=node('div','');row.className='nlt-glass-staff-row';
    const type=damageSummary(item);
    row.append(node('h3',item.name+' · '+messages.home_preferred+': '+item.date),node('p',[item.phone,item.email,item.vehicle,item.address,'CP '+item.zip,type,messages.count_short+': '+item.count,item.notes].filter(Boolean).join('\n')));
    const controls=node('div','');controls.className='nlt-glass-home-controls';
    const km=document.createElement('input');km.type='number';km.min='0.1';km.max='100';km.step='0.1';km.inputMode='decimal';
    const day=document.createElement('input');day.type='date';day.value=item.date;day.min=date.min;day.max=date.max;
    const slot=document.createElement('select');slot.disabled=true;slot.add(new Option(messages.choose_time,''));
    for(const [label,input] of [[messages.home_km,km],[messages.date,day],[messages.home_departure,slot]]){const wrap=node('label',label);wrap.append(input);controls.append(wrap);}
    const quote=node('p',''),notice=node('p',''),calc=node('button',messages.home_calc),confirm=node('button',messages.home_confirm),decline=node('button',messages.home_decline);
    for(const b of [calc,confirm,decline])b.type='button';
    confirm.className='nlt-glass-confirm';confirm.disabled=true;quote.setAttribute('role','status');notice.setAttribute('role','status');
    let calculated='',version=0;
    function invalidate(){version++;calculated='';confirm.disabled=true;slot.disabled=true;slot.replaceChildren(new Option(messages.choose_time,''));quote.textContent='';}
    km.addEventListener('input',invalidate);day.addEventListener('change',invalidate);slot.addEventListener('change',()=>confirm.disabled=!slot.value||!calculated);
    calc.addEventListener('click',async()=>{
     if(!km.value||!km.reportValidity()||!day.value||!day.reportValidity())return;
     const v=++version;calc.disabled=true;notice.textContent=messages.loading_slots;
     const params={date:day.value,km:km.value};
     try{
      const data=await api('home-availability?'+new URLSearchParams(params));if(v!==version)return;
      calculated=JSON.stringify(params);quote.className='nlt-glass-quote';
      quote.textContent=messages.home_quote+': '+new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(data.travel_price)+' · '+data.travel_minutes+' '+messages.home_travel+' · '+data.duration_minutes+' '+messages.home_total+'. '+messages.home_excludes;
      slot.replaceChildren(new Option(messages.choose_time,''));data.slots.forEach(t=>slot.add(new Option(hour(t),t)));slot.disabled=!data.slots.length;notice.textContent=data.slots.length?messages.home_hours:messages.no_slots;
     }catch(e){notice.textContent=e.message;}finally{calc.disabled=false;}
    });
    confirm.addEventListener('click',async()=>{
     if(calculated!==JSON.stringify({date:day.value,km:km.value})){notice.textContent=messages.home_changed;return;}
     if(!slot.value)return;
     const p={id:item.id,date:day.value,time:slot.value,km:Number(km.value)};
     const all=[km,day,slot,calc,confirm,decline];all.forEach(e=>e.disabled=true);notice.textContent=messages.booking;
     try{const saved=await api('home-confirm',p,staffCsrf);row.replaceChildren(node('h3',messages.home_confirmed),node('p',messages.folio+': '+saved.folio+' · '+saved.date+' · '+hour(saved.time)+' – '+hour(saved.end_time)),node('p',messages.home_quote+': '+new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(saved.travel_price)+'. '+messages.home_excludes+' '+messages.home_notified));loadStaff();loadSlots();}
     catch(e){notice.textContent=e.message;all.forEach(e=>e.disabled=false);}
    });
    decline.addEventListener('click',async()=>{if(!window.confirm(messages.home_decline_confirm))return;decline.disabled=true;try{await api('home-decline',{id:item.id},staffCsrf);loadHomeRequests();}catch(e){notice.textContent=e.message;decline.disabled=false;}});
    row.append(controls,quote,calc,confirm,decline,notice);list.append(row);
   }
  }catch(e){if(request===homeSequence)list.textContent=e.message;}
 }

 async function staff(){
  try{
   const response=await fetch((window.Shopify?.routes?.root||'/')+'apps/nlt-taller/session',{credentials:'same-origin',cache:'no-store'});
   if(!response.ok)return;const session=await response.json();if(!session.authorized)return;
   staffCsrf=session.csrf_token;el('GlassStaff').hidden=false;
   const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/Chihuahua',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(p=>[p.type,p.value]));
   el('GlassStaffDate').value=parts.year+'-'+parts.month+'-'+parts.day;loadStaff();loadHomeRequests();
  }catch{}
 }
 loadSlots();staff();
 const timer=setInterval(()=>{if(!document.contains(form)){clearInterval(timer);return;}if(!document.hidden&&date.value&&!form.hidden)loadSlots();},60000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlt-services"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-service-print]');if(!button)return;document.querySelectorAll('[data-printing]').forEach(el=>el.removeAttribute('data-printing'));button.closest('.nlt-service-card').setAttribute('data-printing','');document.body.classList.add('nlt-print-service');window.print();});window.addEventListener('afterprint',function(){document.body.classList.remove('nlt-print-service');document.querySelectorAll('[data-printing]').forEach(el=>el.removeAttribute('data-printing'));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truck-catalog"] && !Shopify.designMode) return;
  try {
    

const nltBuildImagePDF = (pages) => {
  const encode = value => new TextEncoder().encode(value);
  const chunks = [encode('%PDF-1.4\n')];
  const offsets = [0];
  let length = chunks[0].length;
  const append = bytes => { chunks.push(bytes); length += bytes.length; };
  const object = (id, body, binary) => {
    offsets[id] = length;
    append(encode(`${id} 0 obj\n${body}`));
    if (binary) { append(encode('\nstream\n')); append(binary); append(encode('\nendstream')); }
    append(encode('\nendobj\n'));
  };
  object(1, '<< /Type /Catalog /Pages 2 0 R >>');
  let nextID=3;
  const pageIDs=pages.map(page=>{const id=nextID;nextID+=3+(page.links||[]).length;return id;});
  object(2, `<< /Type /Pages /Count ${pages.length} /Kids [${pageIDs.map(id => `${id} 0 R`).join(' ')}] >>`);
  pages.forEach((page, i) => {
    const id = pageIDs[i];
    object(id, `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595.28 841.89] /Resources << /XObject << /Photo ${id+1} 0 R >> >> /Contents ${id+2} 0 R /Annots [${(page.links||[]).map((_,j)=>`${id+3+j} 0 R`).join(' ')}] >>`);
    object(id+1, `<< /Type /XObject /Subtype /Image /Width ${page.width} /Height ${page.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${page.bytes.length} >>`, page.bytes);
    const commands = encode('q 595.28 0 0 841.89 0 0 cm /Photo Do Q');
    object(id+2, `<< /Length ${commands.length} >>`, commands);
    (page.links||[]).forEach((link,j)=>{
      const uri=encodeURI(link.url).replace(/[()\\]/g, char=>'\\'+char);
      object(id+3+j, `<< /Type /Annot /Subtype /Link /Rect [${link.rect.join(' ')}] /Border [0 0 0] /A << /S /URI /URI (${uri}) >> >>`);
    });
  });
  const start = length;
  append(encode(`xref\n0 ${offsets.length}\n0000000000 65535 f \n`));
  offsets.slice(1).forEach(offset => append(encode(`${String(offset).padStart(10,'0')} 00000 n \n`)));
  append(encode(`trailer\n<< /Size ${offsets.length} /Root 1 0 R >>\nstartxref\n${start}\n%%EOF\n`));
  return new Blob(chunks, {type:'application/pdf'});
};
const nltRenderCatalogPDF = async (records, compact, progress, cancelled) => {
  const pages = [];
  const perPage = compact ? 4 : 1;
  const imageFor = src => new Promise((resolve, reject) => {
    if (!src) {resolve(null); return;}
    const img = new Image();
    const timer = setTimeout(() => {img.src='';reject(new Error('Image timeout'));}, 15000);
    img.crossOrigin = 'anonymous';
    img.onload = () => {clearTimeout(timer);resolve(img);};
    img.onerror = () => {clearTimeout(timer);reject(new Error('Image unavailable'));};
    const url = new URL(src, location.href); url.searchParams.set('width', compact ? '700' : '1400');
    img.src = url.href;
  });
  for (let start=0; start<records.length; start+=perPage) {
    if (cancelled()) throw new Error('Cancelled');
    const links=[];
    const canvas = document.createElement('canvas'); canvas.width=1240;canvas.height=1754;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas unavailable');
    ctx.fillStyle=compact?'#e8ecef':'#ffffff';ctx.fillRect(0,0,1240,1754);
    for (let n=0;n<perPage && start+n<records.length;n++) {
      const record=records[start+n];
      const x=compact?40+(n%2)*600:50, y=compact?40+Math.floor(n/2)*837:50;
      const w=compact?560:1140, h=compact?797:1654, pad=compact?24:40;
      const left=x+pad, width=w-pad*2;
      ctx.fillStyle='#fff';ctx.fillRect(x,y,w,h);
      ctx.fillStyle='#25343d';ctx.fillRect(x,y,w,compact?78:115);
      ctx.fillStyle='#cf1426';ctx.fillRect(x,y+(compact?78:115),w,6);
      ctx.font=`italic 900 ${compact?36:58}px Arial`;ctx.fillStyle='#fff';ctx.fillText('NLT',left,y+(compact?43:66));
      ctx.font=`bold ${compact?12:18}px Arial`;ctx.fillText('REFACCIONES',left,y+(compact?64:94));
      const lines=(text,size,maxWidth) => {
        ctx.font=`${size}px Arial`;
        const output=[];let line='';
        for(const paragraph of String(text).split('\n')){
          for(const word of paragraph.split(/\s+/)) {
            if(line && ctx.measureText(line+' '+word).width>maxWidth){output.push(line);line='';}
            if(ctx.measureText(word).width>maxWidth){
              for(const char of word){if(ctx.measureText(line+char).width>maxWidth){output.push(line);line='';}line+=char;}
            } else line+=(line?' ':'')+word;
          }
          output.push(line);line='';
        }
        return output;
      };
      let titleSize=compact?27:43;
      while(lines(record.title,titleSize,width).length>2 && titleSize>16) titleSize--;
      ctx.fillStyle='#25343d';ctx.font=`bold ${titleSize}px Arial`;
      const titleLines=lines(record.title,titleSize,width);ctx.font=`bold ${titleSize}px Arial`;
      titleLines.forEach((line,i)=>ctx.fillText(line,left,y+(compact?117:176)+i*(titleSize+5)));
      let photoY=y+(compact?186:280), photoH=compact?235:570;
      ctx.fillStyle='#eef1f3';ctx.fillRect(left,photoY,width,photoH);
      const img=await imageFor(record.image);
      if(cancelled())throw new Error('Cancelled');
      if(img){const scale=Math.min(width/img.naturalWidth,photoH/img.naturalHeight);const iw=img.naturalWidth*scale,ih=img.naturalHeight*scale;ctx.drawImage(img,left+(width-iw)/2,photoY+(photoH-ih)/2,iw,ih);img.src='';}
      ctx.font=`${compact?15:21}px Arial`;ctx.fillStyle='#55636b';
      ctx.fillText(record.meta.replace(/\s+/g,' ').trim(),left,photoY-12,width);
      ctx.fillStyle='#be1522';ctx.font=`bold ${compact?26:38}px Arial`;
      ctx.fillText(record.price,left,photoY+photoH+(compact?40:60),width);
      const specY=photoY+photoH+(compact?72:115), bottom=y+h-(compact?94:125);
      const columnWidth=(width-24)/2;
      let font=compact?18:25, layout;
      do {
        layout=record.specs.map(spec=>lines(spec,font,columnWidth));
        let needed=0;for(let i=0;i<layout.length;i+=2)needed+=Math.max(layout[i].length,layout[i+1]?.length||0)*(font+7)+15;
        if(needed<=bottom-specY)break;
        font--;
      } while(font>10);
      let rowY=specY;
      ctx.fillStyle='#26343d';ctx.font=`${font}px Arial`;
      for(let i=0;i<layout.length;i+=2){
        const rowHeight=Math.max(layout[i].length,layout[i+1]?.length||0)*(font+7)+15;
        if(rowY+rowHeight>bottom)throw new Error('Specifications exceed page');
        for(let col=0;col<2;col++)(layout[i+col]||[]).forEach((line,j)=>ctx.fillText(line,left+col*(columnWidth+24),rowY+j*(font+7)));
        rowY+=rowHeight;ctx.strokeStyle='#d9dfe3';ctx.beginPath();ctx.moveTo(left,rowY-10);ctx.lineTo(left+width,rowY-10);ctx.stroke();
      }
      ctx.fillStyle='#25343d';ctx.fillRect(left,y+h-(compact?70:85),width,3);
      ctx.font=`${compact?15:22}px Arial`;ctx.fillText('NLT Refacciones · +52 625 111 1643',left,y+h-(compact?43:48));
      ctx.font=`${compact?13:17}px Arial`;ctx.fillStyle='#b51221';ctx.fillText(record.linkLabel||'nltrefacciones.com',left,y+h-20);
      if(record.url)links.push({url:record.url,rect:[left/1240*595.28,(1754-(y+h))/1754*841.89,(left+width)/1240*595.28,(1754-(y+h-40))/1754*841.89]});
      ctx.textAlign='right';ctx.fillText(`${start+n+1} / ${records.length}`,x+w-pad,y+h-20);ctx.textAlign='left';
      progress(start+n+1,records.length);
    }
    const jpeg=canvas.toDataURL('image/jpeg',0.92).split(',')[1];
    pages.push({width:1240,height:1754,links,bytes:Uint8Array.from(atob(jpeg),c=>c.charCodeAt(0))});
    canvas.width=0;canvas.height=0;
    await new Promise(resolve=>setTimeout(resolve,0));
  }
  return nltBuildImagePDF(pages);
};

const initializeTruckComparison = (catalog) => {
  if(catalog.dataset.compareReady) return;
  catalog.dataset.compareReady='true';
  const labels=JSON.parse(catalog.querySelector('[data-compare-labels]').textContent);
  const selected=new Map();
  const bar=catalog.querySelector('[data-compare-bar]');
  const open=catalog.querySelector('[data-compare-open]');
  const dialog=catalog.querySelector('[data-compare-dialog]');
  const table=catalog.querySelector('[data-compare-table]');
  const message=catalog.querySelector('[data-compare-message]');
  const node=(tag,text)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;return el;};
  const update=()=>{
    bar.hidden=selected.size===0;
    open.disabled=selected.size<2;
    catalog.querySelector('[data-compare-count]').textContent=selected.size+' '+labels.selected;
    catalog.querySelectorAll('[data-compare-select]').forEach(input=>{input.checked=selected.has(input.closest('[data-truck-card]').dataset.compareId);});
  };
  const close=()=>{dialog.close();if(!bar.hidden)open.focus();};
  const render=()=>{
    table.replaceChildren();
    const header=node('tr');header.append(node('td',''));
    for(const [id,card] of selected){
      const cell=node('th');cell.scope='col';
      const source=card.querySelector('.truck-card__media img');
      if(source){const img=node('img');img.src=source.currentSrc||source.src;img.alt='';cell.append(img);}
      cell.append(node('div',card.querySelector('h2').textContent.trim()));
      const link=node('a',labels.details);link.href=card.querySelector('h2 a').href;cell.append(link);
      const remove=node('button',labels.remove);remove.type='button';remove.setAttribute('aria-label',labels.remove+' '+card.querySelector('h2').textContent.trim());
      remove.addEventListener('click',()=>{selected.delete(id);update();if(selected.size<2)close();else{render();dialog.querySelector('[data-compare-close]').focus();}});
      cell.append(remove);header.append(cell);
    }
    const head=node('thead');head.append(header);table.append(head);const body=node('tbody');
    const keys=['price','year','make','model','engine','horsepower','transmission','mileage','drivetrain','suspension','differential','import_document','plates','status','location'];
    keys.forEach(key=>{
      const row=node('tr');const title=node('th',labels[key]);title.scope='row';row.append(title);
      for(const card of selected.values()){
        let value=card.getAttribute('data-'+key)||'';
        if(key==='price')value=card.querySelector('.truck-card__price')?.textContent.trim()||card.querySelector('.truck-card__whatsapp')?.textContent.trim()||'';
        if(key==='mileage'&&value)value=Number(value).toLocaleString('es-MX')+' '+card.dataset.mileageUnit;
        row.append(node('td',value.trim()||labels.unknown));
      }
      body.append(row);
    });table.append(body);
  };
  catalog.addEventListener('change',event=>{
    const input=event.target.closest('[data-compare-select]');if(!input)return;
    const card=input.closest('[data-truck-card]');const id=card.dataset.compareId;
    message.textContent='';
    if(input.checked){if(selected.size===3){input.checked=false;message.textContent=labels.limit;return;}selected.set(id,card);}else selected.delete(id);
    update();
  });
  open.addEventListener('click',()=>{if(selected.size<2)return;render();dialog.showModal();dialog.querySelector('[data-compare-close]').focus();});
  catalog.querySelector('[data-compare-clear]').addEventListener('click',()=>{selected.clear();message.textContent='';update();catalog.querySelector('[data-compare-select]')?.focus();});
  dialog.querySelector('[data-compare-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
};

const initializeTruckCatalog = async (catalog) => {
  initializeTruckComparison(catalog);
  if (catalog.dataset.filtersReady) return;
  catalog.dataset.filtersReady = 'true';
  const panel = catalog.querySelector('[data-truck-panel]');
  const mobile = window.matchMedia('(max-width:989px)');
  const updatePanel = () => {
    panel.open = !mobile.matches;
    panel.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
  };
  updatePanel();
  mobile.addEventListener('change', updatePanel);
  const grid = catalog.querySelector('[data-truck-grid]');
  const count = catalog.querySelector('[data-truck-count]');
  const empty = catalog.querySelector('[data-truck-empty]');
  const loading = catalog.querySelector('[data-filter-loading]');
  const pages = new Set([catalog.dataset.catalogPage]);
  const queued = new Set();
  const queue = [];
  const enqueue = (root) => {
    [root.dataset.catalogPrevious, root.dataset.catalogNext].filter(Boolean).forEach((path) => {
      const url = new URL(path, location.href);
      if (url.origin !== location.origin) throw new Error('Invalid catalog page');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (!queued.has(url.href)) { queued.add(url.href); queue.push(url.href); }
    });
  };
  try {
    enqueue(catalog);
    const fragment = document.createDocumentFragment();
    while (queue.length) {
      const response = await fetch(queue.shift());
      if (!response.ok) throw new Error('Catalog page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const page = [...doc.querySelectorAll('.truck-catalog')].find((item) => item.dataset.catalogId === catalog.dataset.catalogId);
      if (!page) throw new Error('Catalog missing');
      if (pages.has(page.dataset.catalogPage)) continue;
      pages.add(page.dataset.catalogPage);
      page.querySelectorAll('[data-truck-card]').forEach((card) => fragment.append(card));
      enqueue(page);
    }
    grid.append(fragment);
    const pagination = catalog.querySelector('.truck-catalog__pagination');
    if (pagination) pagination.hidden = true;
  } catch (error) {
    loading.hidden = true;
    catalog.querySelector('[data-filter-error]').hidden = false;
    return;
  }
  const cards = [...catalog.querySelectorAll('[data-truck-card]')];
  const pdfButton = catalog.querySelector('[data-truck-pdf]');
  const compactButton = catalog.querySelector('[data-truck-compact]');
  const downloadCatalog = (compact = false) => {
    filter();
    const selectedCards = cards.filter(card => !card.hidden);
    if (!selectedCards.length) return;
    const button=compact?compactButton:pdfButton;
    const preview=document.createElement('dialog');
    preview.style.cssText='position:fixed;inset:0;margin:auto;width:calc(100% - 32px);max-width:520px;max-height:85vh;border:0;border-radius:14px;padding:24px;background:white;color:#25343d;z-index:2147483647';
    const title=document.createElement('h2');title.textContent=button.textContent;
    const status=document.createElement('p');status.setAttribute('role','status');status.textContent=pdfButton.dataset.pdfWorking;
    const download=document.createElement('a');download.textContent=button.textContent;download.hidden=true;
    download.style.cssText='display:none;padding:14px;background:#c91523;color:white;border-radius:6px;text-align:center;margin:16px 0;text-decoration:none';
    const close=document.createElement('button');close.type='button';close.textContent=pdfButton.dataset.pdfClose;
    close.style.cssText='padding:12px 18px;border:1px solid #b9c1c6;border-radius:6px;background:white;color:#25343d';
    let blobURL;
    const dismiss=()=>{preview.close();preview.remove();button.focus();if(blobURL)setTimeout(()=>URL.revokeObjectURL(blobURL),60000);};
    close.addEventListener('click',dismiss);preview.addEventListener('cancel',event=>{event.preventDefault();dismiss();});
    preview.append(title,status,download,close);document.body.append(preview);preview.showModal();close.focus();
    const records=selectedCards.map(card=>{
      const lines=(card.dataset.pdfDetails||'').trim().split('\n').filter(line=>line.trim());
      return {
        title:card.querySelector('h2').textContent.trim(),
        meta:card.querySelector('.truck-card__status').textContent+' · '+[...card.querySelector('.truck-card__topline').children].map(el=>el.textContent.trim()).join(' · '),
        url:card.querySelector('h2 a').href,
        linkLabel:card.querySelector('.truck-card__details-link').textContent.trim(),
        image:card.querySelector('.truck-card__media img')?.src,
        price:(lines[1]||'').replace(/^[^:]+:\s*/,''),
        specs:compact?[...card.querySelectorAll('.truck-card__highlights > div')].map(el=>el.querySelector('dt').textContent+': '+el.querySelector('dd').textContent):lines.slice(2).filter(line=>!/^https?:\/\//.test(line.trim())&&!/^(Estado|Stock):/.test(line.trim()))
      };
    });
    nltRenderCatalogPDF(records,compact,(done,total)=>{status.textContent=pdfButton.dataset.pdfWorking+' '+done+' / '+total;},()=>!preview.isConnected).then(blob=>{
      if(!preview.isConnected)return;
      blobURL=URL.createObjectURL(blob);download.href=blobURL;
      download.download=compact?'NLT-Catalogo-Compacto.pdf':'NLT-Catalogo-Camiones.pdf';
      download.hidden=false;download.style.display='block';status.textContent=pdfButton.dataset.pdfReady;
      download.focus();
    }).catch(error=>{
      if(preview.isConnected)status.textContent=pdfButton.dataset.pdfError;
      console.error('NLT catalog PDF:',error);
    });
  };
  pdfButton.addEventListener('click', () => downloadCatalog(false));
  compactButton.addEventListener('click', () => downloadCatalog(true));

  const search = catalog.querySelector('[data-truck-search]');
  const min = catalog.querySelector('[data-truck-price-min]');
  const max = catalog.querySelector('[data-truck-price-max]');
  const normalize = (value) => value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const groups = [...catalog.querySelectorAll('[data-truck-facet]')];
  const records = cards.map((card) => ({
    card,
    text: normalize(card.textContent + ' ' + Object.values(card.dataset).join(' ')),
    fields: Object.fromEntries(groups.map((group) => [group.dataset.truckFacet, normalize(card.getAttribute('data-' + group.dataset.truckFacet) || '')])),
    price: card.dataset.price.trim() === '' ? null : Number(card.dataset.price)
  }));
  groups.forEach((group) => {
    const key = group.dataset.truckFacet;
    const labels = new Map();
    cards.forEach((card) => {
      const label = (card.getAttribute('data-' + key) || '').trim();
      if (label) labels.set(normalize(label), label);
    });
    [...labels].sort((a, b) => key === 'year' ? Number(b[0]) - Number(a[0]) : a[1].localeCompare(b[1], undefined, {numeric:true})).forEach(([value, text]) => {
      const label = document.createElement('label');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = value;
      checkbox.dataset.facet = key;
      const name = document.createElement('span');
      name.textContent = key === 'status' ? text.charAt(0).toUpperCase() + text.slice(1) : text;
      const total = document.createElement('span');
      total.className = 'truck-catalog__option-count';
      label.append(checkbox, name, total);
      group.append(label);
    });
    group.closest('details').hidden = labels.size === 0;
  });
  const filter = () => {
    const selected = Object.fromEntries(groups.map((group) => [group.dataset.truckFacet, [...group.querySelectorAll('input:checked')].map((input) => input.value)]));
    const term = normalize(search.value);
    const low = min.value === '' ? null : Number(min.value);
    const high = max.value === '' ? null : Number(max.value);
    const matches = (record, except) => (!term || record.text.includes(term)) &&
      (low === null || (record.price !== null && record.price >= low)) &&
      (high === null || (record.price !== null && record.price <= high)) &&
      Object.entries(selected).every(([key, values]) => key === except || !values.length || values.includes(record.fields[key]));
    let visible = 0;
    records.forEach((record) => { record.card.hidden = !matches(record); if (!record.card.hidden) visible++; });
    count.textContent = visible;
    pdfButton.disabled = visible === 0;
    compactButton.disabled = visible === 0;
    empty.hidden = visible !== 0 || records.length === 0;
    groups.forEach((group) => {
      const key = group.dataset.truckFacet;
      const badge = catalog.querySelector('[data-facet-selected="' + key + '"]');
      badge.textContent = selected[key].length ? '(' + selected[key].length + ')' : '';
      group.querySelectorAll('input').forEach((input) => {
        const total = records.filter((record) => record.fields[key] === input.value && matches(record, key)).length;
        input.parentElement.querySelector('.truck-catalog__option-count').textContent = '(' + total + ')';
      });
    });
  };
  catalog.querySelector('.truck-catalog__filters').addEventListener('input', filter);
  catalog.querySelectorAll('[data-truck-reset]').forEach((button) => button.addEventListener('click', () => {
    search.value = ''; min.value = ''; max.value = '';
    catalog.querySelectorAll('[data-facet]').forEach((input) => { input.checked = false; });
    filter();
  }));
  filter();
  loading.hidden = true;
  catalog.querySelector('fieldset').disabled = false;
};
const initializeTruckCatalogs = (root) => root.querySelectorAll('.truck-catalog').forEach(initializeTruckCatalog);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeTruckCatalogs(document));
else initializeTruckCatalogs(document);
document.addEventListener('shopify:section:load', (event) => initializeTruckCatalogs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truck-detail"]) return;
  try {
    
document.querySelectorAll('[data-truck-gallery]').forEach((gallery) => {
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
  const thumbnailStrip = gallery.querySelector('[data-gallery-thumbnails]');
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  const lightbox = gallery.querySelector('[data-gallery-lightbox]');
  const lightboxImage = gallery.querySelector('[data-lightbox-image]');
  const lightboxPrevious = gallery.querySelector('[data-lightbox-previous]');
  const lightboxNext = gallery.querySelector('[data-lightbox-next]');
  const lightboxClose = gallery.querySelector('[data-gallery-close]');
  let current = 0;

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const active = thumbnailIndex === current;
      thumbnail.classList.toggle('is-active', active);
      if (active) {
        thumbnail.setAttribute('aria-current', 'true');
        if (thumbnailStrip) {
          const stripBounds = thumbnailStrip.getBoundingClientRect();
          const thumbnailBounds = thumbnail.getBoundingClientRect();
          thumbnailStrip.scrollBy({
            left: thumbnailBounds.left - stripBounds.left - (thumbnailStrip.clientWidth - thumbnailBounds.width) / 2,
            behavior: 'smooth'
          });
        }
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });
    if (lightbox.open) {
      const activeImage = slides[current].querySelector('img');
      lightboxImage.removeAttribute('srcset');
      lightboxImage.removeAttribute('sizes');
      lightboxImage.src = slides[current].href;
      lightboxImage.alt = activeImage.alt;
    }
  };

  const openLightbox = (index) => {
    show(index);
    const activeImage = slides[current].querySelector('img');
    lightboxImage.removeAttribute('srcset');
    lightboxImage.removeAttribute('sizes');
    lightboxImage.src = slides[current].href;
    lightboxImage.alt = activeImage.alt;
    lightbox.showModal();
  };

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => show(Number(thumbnail.dataset.galleryThumbnail)));
  });
  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  slides.forEach((slide, index) => {
    slide.addEventListener('click', (event) => {
      event.preventDefault();
      openLightbox(index);
    });
  });
  lightboxPrevious.addEventListener('click', () => show(current - 1));
  lightboxNext.addEventListener('click', () => show(current + 1));
  lightboxClose.addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });
  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(current - 1);
    if (event.key === 'ArrowRight') show(current + 1);
  });

  if (slides.length < 2) {
    previous.hidden = true;
    next.hidden = true;
    lightboxPrevious.hidden = true;
    lightboxNext.hidden = true;
  }
});

  } catch(e) { console.error(e); }
})();
})();
